import PBService from "@irati/utils/services"
import {
  MutationUpdateBillingZuoraSoldToContactArgs,
  TeamRegionMap,
  ZuoraCurrentPlan,
  MutationBillingFindOrCreateUnitForRegionIdArgs,
  QueryBillingUnitsArgs,
  QueryBillingUnitForRegionIdArgs,
  QueryBillingZuoraSeatsCountArgs,
  QueryBillingZuoraInvoicesArgs,
  QueryBillingZuoraInvoiceArgs,
  QueryBillingZuoraCurrentPlanArgs,
  ZuoraSeatsCount,
  ZuoraInvoices,
  ZuoraInvoice,
  QueryBillingZuoraProductOptionsArgs,
  ZuoraProductOptions,
  QueryBillingZuoraSoldToContactArgs,
  ZuoraSoldToContact
} from "@irati/types"
import client, {MutationOptions, QueryOptions} from "@irati/utils/services/apollo"
import createForRegionMutation, {createForRegionKey} from "./mutations/createForRegion"
import billingUnitsQuery, {billingUnitsKey} from "./query/billingUnits"
import billingUnitForRegionQuery, {billingUnitForRegionKey} from "./query/billingUnitForRegion"
import billingSeatsCountQuery, {billingZuoraSeatsCountKey} from "./query/billingSeatsCount"
import billingInvoicesQuery, {billingZuoraInvoicesKey} from ".//query/billingInvoices"
import billingInvoiceQuery, {billingZuoraInvoiceKey} from "./query/billingInvoice"
import billingCurrentPlanQuery, {billingCurrentPlanKey} from "./query/billingCurrentPlan"
import billingProductOptionsQuery, {billingProductOptionsKey} from "./query/billingProductOptions"
import billingZuoraSoldToContact, {billingZuoraSoldToContactKey} from "./query/billingZuoraSoldToContact"
import updateBillingZuoraSoldToContact, {updateBillingZuoraSoldToContactKey} from "./mutations/updateBillingZuoraSoldToContact"

class BUService extends PBService {
  async list({businessId}: QueryBillingUnitsArgs, options: QueryOptions = {}): Promise<TeamRegionMap[]> {
    const variables = {businessId}
    return client.query({...options, query: billingUnitsQuery, variables}).then(({data}) => data[billingUnitsKey])
  }

  async getForRegionId({businessId, regionId}: QueryBillingUnitForRegionIdArgs, options: QueryOptions = {}): Promise<TeamRegionMap> {
    const variables = {businessId, regionId}
    return client.query({...options, query: billingUnitForRegionQuery, variables}).then(({data}) => data[billingUnitForRegionKey])
  }

  async getSeatsCount({businessId}: QueryBillingZuoraSeatsCountArgs, options: QueryOptions = {}): Promise<ZuoraSeatsCount> {
    const variables = {businessId}
    return client.query({...options, query: billingSeatsCountQuery, variables}).then(({data}) => data[billingZuoraSeatsCountKey])
  }

  async getInvoices({businessId}: QueryBillingZuoraInvoicesArgs, options: QueryOptions = {}): Promise<ZuoraInvoices> {
    const variables = {businessId}
    return client.query({...options, query: billingInvoicesQuery, variables}).then(({data}) => data[billingZuoraInvoicesKey])
  }

  async getInvoiceBody({invoiceId}: QueryBillingZuoraInvoiceArgs, options: QueryOptions = {}): Promise<ZuoraInvoice> {
    const variables = {invoiceId}
    return client.query({...options, query: billingInvoiceQuery, variables}).then(({data}) => data[billingZuoraInvoiceKey])
  }

  async getCurrentPlan({businessId}: QueryBillingZuoraCurrentPlanArgs, options: QueryOptions = {}): Promise<ZuoraCurrentPlan> {
    const variables = {businessId}
    return client.query({...options, query: billingCurrentPlanQuery, variables}).then(({data}) => data[billingCurrentPlanKey])
  }

  async createForRegion(
    {businessId, regionId}: MutationBillingFindOrCreateUnitForRegionIdArgs,
    options: MutationOptions = {}
  ): Promise<TeamRegionMap> {
    const variables = {businessId, regionId}

    return client.mutate({...options, mutation: createForRegionMutation, variables}).then(({data}) => {
      const businessUnit = data[createForRegionKey]
      return businessUnit
    })
  }

  async getProductOptions({businessId}: QueryBillingZuoraProductOptionsArgs, options: QueryOptions = {}): Promise<ZuoraProductOptions> {
    const variables = {businessId}
    return client.query({...options, query: billingProductOptionsQuery, variables}).then(({data}) => data[billingProductOptionsKey])
  }

  async getSoldToContact({businessId}: QueryBillingZuoraSoldToContactArgs, options: QueryOptions = {}): Promise<ZuoraSoldToContact> {
    const variables = {businessId}
    return client.query({...options, query: billingZuoraSoldToContact, variables}).then(({data}) => data[billingZuoraSoldToContactKey])
  }

  async updateSoldToContact(variables: MutationUpdateBillingZuoraSoldToContactArgs, options: MutationOptions = {}) {
    return client
      .mutate({...options, mutation: updateBillingZuoraSoldToContact, variables})
      .then(({data}) => data[updateBillingZuoraSoldToContactKey])
  }
}

const buService = new BUService({errorHandlers: []})

export default buService
